<template>
  <a-modal
    title="绑定模板"
    width="80%"
    :visible="visible"
    :maskStyle="{'top':'93px','left':'154px'}"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="取消"
    okText="保存"
    style="top:5%;height: 90%;">
    <templateList ref="templatelist" :choose="true" :item="item"></templateList>
  </a-modal>
</template>

<script>
import templateList from '@/views/H5Create/templateList.vue'
import { modifyForTemplate } from '@api/api'
export default {
  name: "chooseTemplate",
  components: {
    templateList
  },
  data () {
    return {
      visible: false,
      item:{}
    }
  },
  methods:{
    open(item){
      this.item = item
      this.visible = true
      this.$nextTick(()=>{
        this.$refs.templatelist.open()
      })
    },
    handleCancel(){
      this.visible = false
    },
    handleOk(){


      if(this.item.selectedRowKeys.length != 1){
        this.$message.error('请选择1个页面模板')
      }else{
        this.item.htmlTemplateId = this.item.selectedRowKeys[0]

        console.log('模板选择完成!!!!!',this.item)

        modifyForTemplate({
          ruleId:this.item.uuid,
          templateId:this.item.htmlTemplateId
        }).then((res)=>{
          this.$message.success(res.message)
          this.$emit('ok')
          this.$nextTick(()=>{
            this.visible = false
          })
        });
      }
    }
  }
}

</script>

<style scoped>

</style>